import {
    REQUEST_BUSINESSCASES_COLUMNS,
    RECEIVE_BUSINESSCASES_COLUMNS,
    UPDATE_BUSINESSCASES_COLUMNS,
    ERROR_BUSINESSCASES_COLUMNS,
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"


export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_BUSINESSCASES_COLUMNS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_BUSINESSCASES_COLUMNS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case UPDATE_BUSINESSCASES_COLUMNS:
            const data = state.data
            let index = null
            if(data.results){
                if(action.updateType == "delete"){
                    index = data.results.findIndex(item => item.id == action.id)
                    data.results.splice(index, 1)
                }else{
                    index = data.results.findIndex(item => item.id == action.id)
                    if(index > -1){
                        data.results[index] = action.payload
                    }else{
                        const payload = action.payload
                        if(typeof payload.cards == "undefined"){
                            payload.cards = []
                        }
                        data.results.unshift(payload)
                    }
                }
            }
            return {
                ...state,
                isFetching: false,
                data,
                errors: action.errors
            }
        case ERROR_BUSINESSCASES_COLUMNS:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}